var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeskalaFooterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 84,
    viewBox: "0 0 275 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7843 83.5684H5.91298C2.64737 83.5684 0 80.921 0 77.6555L0 5.91298C0 2.64737 2.64737 0 5.91298 0L41.7843 0C64.861 0 83.5684 18.7074 83.5684 41.7841V41.7843C83.5684 64.861 64.861 83.5684 41.7843 83.5684Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5234 17.2329V29.7251C46.5234 36.6244 40.9305 42.2173 34.0312 42.2173H21.5391C21.5391 28.4188 32.725 17.2329 46.5234 17.2329Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5391 41.3533H34.0312C40.9305 41.3533 46.5234 46.9462 46.5234 53.8455V66.3376C32.725 66.3376 21.5391 55.1517 21.5391 41.3533Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.599 42.3106C125.599 37.5948 122.415 34.6548 118.029 34.6548C113.643 34.6548 110.457 37.5948 110.457 42.3106V49.2056C110.457 53.9204 113.643 56.8613 118.029 56.8613C122.415 56.8613 125.599 53.9204 125.599 49.2056V42.3106ZM126.983 58.9399C126.218 58.9399 125.599 58.3383 125.599 57.5962V55.746C123.98 58.1792 121.004 59.4467 118.029 59.4467C113.171 59.4467 107.689 56.8106 107.689 49.2056V42.3106C107.689 34.7057 113.171 32.0694 118.029 32.0694C121.004 32.0694 123.98 33.3361 125.599 35.7701V25.4678C125.599 24.7256 126.218 24.124 126.983 24.124C127.747 24.124 128.366 24.7256 128.366 25.4678V57.5962C128.366 58.3383 127.747 58.9399 126.983 58.9399Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.894 43.4151H154.063V42.1898C154.063 37.4412 150.873 34.4803 146.479 34.4803C142.086 34.4803 138.894 37.4412 138.894 42.1898V43.4151ZM169.647 59.4457H146.479C141.613 59.4457 136.122 56.791 136.122 49.1325V42.1898C136.122 34.5313 141.613 31.8767 146.479 31.8767C151.344 31.8767 156.835 34.5313 156.835 42.1898V44.2199C156.835 45.2134 156.01 46.0186 154.993 46.0186H139.815C139.307 46.0186 138.894 46.4213 138.894 46.918V49.1325C138.894 53.8803 142.086 56.8421 146.479 56.8421H169.722L169.647 59.4457Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.68 56.8397C173.268 56.8397 176.441 55.4094 176.441 52.3977C176.441 49.9475 175.088 48.1091 171.864 47.4454L165.83 46.1187C162.085 45.301 159.382 43.2079 159.382 39.0723C159.382 34.3245 163.959 31.8743 168.742 31.8743C173.182 31.8743 177.088 34.0135 178.228 38.4003C178.456 39.2804 177.802 40.1451 176.877 40.1451C176.226 40.1451 175.683 39.6964 175.517 39.0778C174.733 36.1578 172.046 34.4778 168.691 34.4778C165.413 34.4778 162.138 35.8045 162.138 39.0723C162.138 41.4722 163.49 42.7998 166.766 43.5138L171.915 44.6373C176.96 45.7092 179.197 48.0068 179.197 52.4488C179.197 56.993 175.296 59.4432 169.626 59.4432",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.332 46.9212L199.151 33.6911C199.402 33.4309 199.757 33.2826 200.129 33.2826C201.29 33.2826 201.896 34.5969 201.11 35.4088L193.206 43.575L203.093 57.4656C203.692 58.3075 203.058 59.4441 201.989 59.4441H201.849C201.408 59.4441 200.994 59.236 200.747 58.8887L191.234 45.5525L186.332 50.6223V58.1765C186.332 58.8769 185.736 59.4441 185 59.4441H184.841C184.105 59.4441 183.509 58.8769 183.509 58.1765V25.3889C183.509 24.6889 184.105 24.1213 184.841 24.1213H185C185.736 24.1213 186.332 24.6889 186.332 25.3889V46.9212Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.368 58.1011V25.4654C240.368 24.7232 240.947 24.1221 241.66 24.1221C242.374 24.1221 242.953 24.7232 242.953 25.4654V58.1011C242.953 58.8432 242.374 59.4448 241.66 59.4448C240.947 59.4448 240.368 58.8432 240.368 58.1011Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.412 33.5969C220.953 33.5969 220.494 33.8268 220.248 34.2868L207.781 57.5545C207.32 58.4125 207.956 59.4428 208.945 59.4428H233.88C234.869 59.4428 235.505 58.4125 235.044 57.5545L222.577 34.2868C222.331 33.8268 221.872 33.5969 221.412 33.5969ZM221.412 37.8051L231.589 56.7965H211.236L221.412 37.8051Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1405_1004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 247,
    y: 34,
    width: 28,
    height: 26
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.463 34.0022H275V59.6222H247.463V34.0022Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1405_1004)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.232 34.0022C260.773 34.0022 260.314 34.23 260.069 34.6861L247.615 57.7504C247.156 58.6009 247.791 59.6222 248.779 59.6222H273.684C274.672 59.6222 275.307 58.6009 274.847 57.7504L262.395 34.6861C262.149 34.23 261.69 34.0022 261.232 34.0022ZM261.232 38.1736L271.396 56.9989H251.067L261.232 38.1736Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskalaFooterIcon);
export default __webpack_public_path__ + "static/media/deskalaFooterIcon.d3b0e4a04659afb4443349f0ed8ba54b.svg";
export { ForwardRef as ReactComponent };